import axios from 'axios'
import IUserFormLogin from '@/models/user/implements/IUserFormLogin.type'
import UserFormLoginResult from '@/models/user/forms/UserFormLoginResult'

const httpClient = axios.create({
  baseURL: 'http://localhost:3000',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
    'Accept-Language': 'fr'
  }
})

class AuthServices {
  async login (userForm: IUserFormLogin) {
    return await httpClient.post<UserFormLoginResult>('/login', {
      email: userForm.Email,
      password: userForm.Password
    })
  }
}

export default new AuthServices()
